import React from 'react';
import { createPortal } from 'react-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { DEMO_SIGNUP_URL } from '@/lib/demoMode';

interface DemoSignupModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
}

/**
 * Shown when a visitor hits a signup-gated action (Save, Test) in the public
 * demo builder. Chrome mirrors SimulatedModePromptModal.
 */
export function DemoSignupModal({ open, onClose, title, description }: DemoSignupModalProps) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50" onClick={onClose}>
      <div
        className="bg-background border rounded-lg shadow-xl max-w-lg w-full m-4"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="demo-signup-title"
      >
        <div className="px-5 py-4 border-b">
          <h3 id="demo-signup-title" className="text-base font-semibold">
            {title}
          </h3>
        </div>

        <div className="px-5 py-4">
          <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
        </div>

        <div className="flex justify-end gap-2 px-5 py-3 border-t">
          <Button variant="outline" size="sm" onClick={onClose}>
            Keep building
          </Button>
          <Button size="sm" asChild className="gap-1.5">
            <a href={DEMO_SIGNUP_URL} target="_blank" rel="noopener noreferrer">
              Start free trial
              <ArrowRight className="w-3.5 h-3.5" />
            </a>
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
